function initHelpdeskWidget(name, email) {
  if ("function" == typeof window.FreshworksWidget) {
    window.FreshworksWidget("hide", "launcher");

    window.FreshworksWidget("identify", "ticketForm", {
      name: name,
      email: email,
    });
  }
}

function showHelpdesk() {
  window.FreshworksWidget("open");
}

function initialiseSalesForceChat(user) {
  initEmbeddedMessaging(user);
}

function initEmbeddedMessaging(user) {
  try {
    embeddedservice_bootstrap.settings.language = "en_US"; // For example, enter 'en' or 'en-US'
    embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;

    embeddedservice_bootstrap.init(
      window.salesforce_org_id,
      window.salesforce_msg_service_name,
      `https://mitimes.my.site.com/${window.salesforce_msg_service_id}`,
      {
        scrt2URL: "https://mitimes.my.salesforce-scrt.com",
      },
    );

    window.addEventListener("onEmbeddedMessagingReady", () => {
      // Send data to Salesforce
      embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
        "Id": user.id,
        "Name": user.name,
        "FirstName": user.firstName,
        "LastName": user.surname,
        "Email": user.email,
        "UserId": user.id,
        "OrganisationId": user.organisationId,
        "OrganisationName": user.organisationName,
        "ServerHost": window.location.hostname,
      });
    });
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
}

function startSalesForceChat() {
  embeddedservice_bootstrap.utilAPI.launchChat()
    .then(() => {
      console.log("Salesforce chat launched");
    }).catch(() => {
      console.log("Salesforce chat launch failed");
    }).finally(() => {
      embeddedservice_bootstrap.utilAPI.hideChatButton();
    });
}

// To have a user maintain a conversation past the length of a session.
// add the following (NOTE Would require JWTs):
// window.addEventListener("onEmbeddedMessagingIdentityTokenExpired", () => {
//     console.log("Received the onEmbeddedMessagingIdentityTokenExpired event…");
//
//     // Refresh token and then send the new token to Salesforce
//     embeddedservice_bootstrap.userVerificationAPI.setIdentityToken({
//     identityTokenType : "JWT", identityToken : refreshed_jwt});
//
//     // Or, instead of refreshing the token, call
//     // embeddedservice_bootstrap.userVerificationAPI.clearSession()
//     // to clear all session data…
// });
//
// // TO DO: Be sure to call clearSession when user logs out.
// // This is a sample function that includes the clearSession
// // call…
// function onUserLogout() {
//     embeddedservice_bootstrap.userVerificationAPI.clearSession()
//      .then(() => {
//           // TO DO: Handle success
//      })
//      .catch(error => {
//           // TO DO: Handle error
//      })
//      .finally(() => {
//           // TO DO: Handle regardless of result
//      });
//
//     // TO DO: Perform any other logout actions
// }

export default {
  initHelpdeskWidget,
  showHelpdesk,
  initialiseSalesForceChat,
  startSalesForceChat,
};
